import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Grid, IconButton, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { APIURL } from '../../../config';
import SaveButton from '../Components/SaveButton';
import CancelButton from '../Components/CancelButton';

const EmployeeLeaveInformation = ({ employee, setEmployee, comp_id, canEdit }) => {
    const [editMode, setEditMode] = useState(false);
    const [vacationDays, setVacationDays] = useState(employee?.emp_vacation ?? '');
    const [personalDays, setPersonalDays] = useState(employee?.emp_personal ?? '');

    useEffect(() => {
        setVacationDays(employee?.emp_vacation ?? '');
        setPersonalDays(employee?.emp_personal ?? '');
    }, [employee]);

    const handleCancel = () => {
        setVacationDays(employee?.emp_vacation ?? '');
        setPersonalDays(employee?.emp_personal ?? '');
        setEditMode(false);
    };

    const handleSave = async () => {
        const updatedEmployee = {
            ...employee,
            emp_vacation: vacationDays,
            emp_personal: personalDays,
        };

        await axios.put(`${APIURL}/employees`, {
            ...updatedEmployee,
            emp_id: employee.emp_id,
            company_id: comp_id,
            email: employee.empEmail,
            first_name: employee.emp_first_name,
            last_name: employee.emp_last_name,
            address1: employee.emp_addr_line1,
            address2: employee.emp_addr_line2,
            city: employee.emp_city,
            state: employee.emp_state,
            zip: employee.emp_zip,
            phoneList: employee.emp_phone_number,
            join_date: employee.emp_join_date,
            status: employee.emp_status,
            employee_type: employee.emp_type,
            employee_level: employee.emp_level,
            vacation_days: vacationDays,
            personal_days_off: personalDays,
            dob: employee.dob,
            terminationDate: employee.date_of_termination,
            terminationReason: employee.termination_reason,
            emp_manager_id: employee.emp_manager_id,
            telemedRoom: employee.emp_doxylink,
            emp_stateRegistraionID: employee.emp_stateRegistraionID,
            emp_stateRegistraionType: employee.emp_stateRegistraionType,
            emp_professionalLicenseNumber: employee.emp_professionalLicenseNumber,
            emp_local_id: employee.emp_local_id,
            compensation_type: employee.compensation_type,
            compensation_rate: employee.compensation_rate,
        });

        setEmployee(updatedEmployee);
        setEditMode(false);
    };

    return (
        <Box sx={{ px: 2, py: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box>
                    <Typography variant="h6">Sick and Vacation Days</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Review the employee's available leave balances.
                    </Typography>
                </Box>
                {canEdit && (editMode ? (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <CancelButton onClick={handleCancel} />
                        <SaveButton onClick={handleSave} />
                    </Box>
                ) : (
                    <IconButton color="primary" onClick={() => setEditMode(true)} aria-label="Edit leave balances">
                        <EditIcon />
                    </IconButton>
                ))}
            </Box>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    {editMode ? (
                        <TextField
                            label="Vacation Days"
                            type="number"
                            value={vacationDays}
                            onChange={(event) => setVacationDays(event.target.value)}
                            fullWidth
                            size="small"
                        />
                    ) : (
                        <Box>
                            <Typography variant="body2" color="text.secondary">Vacation Days</Typography>
                            <Typography variant="h6">{vacationDays || 0}</Typography>
                        </Box>
                    )}
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    {editMode ? (
                        <TextField
                            label="Sick / Personal Days"
                            type="number"
                            value={personalDays}
                            onChange={(event) => setPersonalDays(event.target.value)}
                            fullWidth
                            size="small"
                        />
                    ) : (
                        <Box>
                            <Typography variant="body2" color="text.secondary">Sick / Personal Days</Typography>
                            <Typography variant="h6">{personalDays || 0}</Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default EmployeeLeaveInformation;
